// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
}

.contact-header {
  background: white;
  border-bottom: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 50;
}

.header-content {
  max-width: 1560px;
  margin: 0 auto;
  padding: 0 24px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo-link {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  font-size: 18px;
  text-decoration: none;
}

.logo-icon {
  width: 34px;
  height: 34px;
  border-radius: 12px;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  display: grid;
  place-items: center;
  color: white;
  font-size: 14px;
  font-weight: 800;
  box-shadow: 0 4px 6px rgba(99, 102, 241, 0.3);
}

.logo-text {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 12px;
}

.nav-link {
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  text-decoration: none;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.nav-link:hover {
  color: #6366f1;
  background: #f5f3ff;
}

.nav-link.active {
  color: #6366f1;
  background: #f5f3ff;
  font-weight: 600;
}

.contact-container {
  padding: 80px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.contact-wrapper {
  display: grid;
  grid-template-columns: 1fr 1.5fr;
  gap: 0;
  max-width: 1200px;
  width: 100%;
  background: white;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.contact-info {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  padding: 60px 40px;
  color: white;
}

.contact-info h1 {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 20px;
}

.contact-subtitle {
  font-size: 18px;
  line-height: 1.6;
  margin-bottom: 40px;
  opacity: 0.95;
}

.contact-details {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 20px;
}

.contact-icon {
  font-size: 32px;
  background: rgba(255, 255, 255, 0.2);
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
}

.contact-text h3 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 5px;
}

.contact-text p {
  font-size: 16px;
  opacity: 0.9;
}

.contact-form-container {
  padding: 60px 40px;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-group label {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.form-group input,
.form-group textarea {
  padding: 14px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 16px;
  font-family: inherit;
  transition: all 0.3s ease;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.form-group input.error,
.form-group textarea.error {
  border-color: #e74c3c;
}

.form-group textarea {
  resize: vertical;
  min-height: 120px;
}

.char-count {
  font-size: 12px;
  color: #888;
  text-align: right;
  margin-top: -4px;
}

.error-message {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #b91c1c;
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 14px;
}

.form-group .error-message {
  background: none;
  border: none;
  border-radius: 0;
  padding: 0;
  color: #e74c3c;
  font-size: 13px;
}

.alert {
  padding: 14px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
}

.alert.success {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.submit-button {
  padding: 16px 32px;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 10px;
}

.submit-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(99, 102, 241, 0.4);
}

.submit-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Responsive Design */
@media (max-width: 968px) {
  .contact-wrapper {
    grid-template-columns: 1fr;
  }

  .contact-info {
    padding: 40px 30px;
  }

  .contact-form-container {
    padding: 40px 30px;
  }

  .nav-links {
    gap: 8px;
  }

  .nav-link {
    padding: 6px 12px;
    font-size: 13px;
  }
}

@media (max-width: 640px) {
  .contact-container {
    padding: 20px 10px;
  }

  .contact-info h1 {
    font-size: 36px;
  }

  .contact-subtitle {
    font-size: 16px;
  }

  .contact-info,
  .contact-form-container {
    padding: 30px 20px;
  }

  .logo-text {
    display: none;
  }

  .nav-links {
    gap: 4px;
  }

  .nav-link {
    padding: 6px 10px;
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Contact.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,wCAAwC;EACxC,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,MAAM;EACN,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":[".contact-page {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);\n}\n\n.contact-header {\n  background: white;\n  border-bottom: 1px solid #e5e7eb;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  position: sticky;\n  top: 0;\n  z-index: 50;\n}\n\n.header-content {\n  max-width: 1560px;\n  margin: 0 auto;\n  padding: 0 24px;\n  height: 64px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.logo-link {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-weight: 700;\n  font-size: 18px;\n  text-decoration: none;\n}\n\n.logo-icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);\n  display: grid;\n  place-items: center;\n  color: white;\n  font-size: 14px;\n  font-weight: 800;\n  box-shadow: 0 4px 6px rgba(99, 102, 241, 0.3);\n}\n\n.logo-text {\n  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.nav-links {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.nav-link {\n  padding: 8px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #6b7280;\n  text-decoration: none;\n  border-radius: 12px;\n  transition: all 0.3s ease;\n}\n\n.nav-link:hover {\n  color: #6366f1;\n  background: #f5f3ff;\n}\n\n.nav-link.active {\n  color: #6366f1;\n  background: #f5f3ff;\n  font-weight: 600;\n}\n\n.contact-container {\n  padding: 80px 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.contact-wrapper {\n  display: grid;\n  grid-template-columns: 1fr 1.5fr;\n  gap: 0;\n  max-width: 1200px;\n  width: 100%;\n  background: white;\n  border-radius: 20px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n}\n\n.contact-info {\n  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);\n  padding: 60px 40px;\n  color: white;\n}\n\n.contact-info h1 {\n  font-size: 48px;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n\n.contact-subtitle {\n  font-size: 18px;\n  line-height: 1.6;\n  margin-bottom: 40px;\n  opacity: 0.95;\n}\n\n.contact-details {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n}\n\n.contact-item {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.contact-icon {\n  font-size: 32px;\n  background: rgba(255, 255, 255, 0.2);\n  width: 60px;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 12px;\n}\n\n.contact-text h3 {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 5px;\n}\n\n.contact-text p {\n  font-size: 16px;\n  opacity: 0.9;\n}\n\n.contact-form-container {\n  padding: 60px 40px;\n}\n\n.contact-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.form-group label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n}\n\n.form-group input,\n.form-group textarea {\n  padding: 14px 16px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 16px;\n  font-family: inherit;\n  transition: all 0.3s ease;\n}\n\n.form-group input:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #6366f1;\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);\n}\n\n.form-group input.error,\n.form-group textarea.error {\n  border-color: #e74c3c;\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 120px;\n}\n\n.char-count {\n  font-size: 12px;\n  color: #888;\n  text-align: right;\n  margin-top: -4px;\n}\n\n.error-message {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #b91c1c;\n  border-radius: 12px;\n  padding: 12px 16px;\n  font-size: 14px;\n}\n\n.form-group .error-message {\n  background: none;\n  border: none;\n  border-radius: 0;\n  padding: 0;\n  color: #e74c3c;\n  font-size: 13px;\n}\n\n.alert {\n  padding: 14px 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.alert.success {\n  background: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.submit-button {\n  padding: 16px 32px;\n  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 10px;\n}\n\n.submit-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(99, 102, 241, 0.4);\n}\n\n.submit-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Responsive Design */\n@media (max-width: 968px) {\n  .contact-wrapper {\n    grid-template-columns: 1fr;\n  }\n\n  .contact-info {\n    padding: 40px 30px;\n  }\n\n  .contact-form-container {\n    padding: 40px 30px;\n  }\n\n  .nav-links {\n    gap: 8px;\n  }\n\n  .nav-link {\n    padding: 6px 12px;\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 640px) {\n  .contact-container {\n    padding: 20px 10px;\n  }\n\n  .contact-info h1 {\n    font-size: 36px;\n  }\n\n  .contact-subtitle {\n    font-size: 16px;\n  }\n\n  .contact-info,\n  .contact-form-container {\n    padding: 30px 20px;\n  }\n\n  .logo-text {\n    display: none;\n  }\n\n  .nav-links {\n    gap: 4px;\n  }\n\n  .nav-link {\n    padding: 6px 10px;\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
